<i18n>
  {
    "fr": {
      "user-dashboard-resources": "Ressources"
    },
    "en": {
      "user-dashboard-resources": "Resources"
    }
  }
</i18n>
<template>
  <ui-box>
    <h2 class="title is-3 has-text-weight-bold">{{ $t('user-dashboard-resources') }}</h2>
    <div class="columns">
      <div v-if="$prismicHasText(prismicContent.resource1_description)" class="column is-flex">
        <resource-snippet
          :title="$prismicText(prismicContent.resource1_description)"
          :link="prismicContent.resource1_link"
          :image="require('@/assets/ressource-01.svg')"
        />
      </div>
      <div v-if="$prismicHasText(prismicContent.resource2_description)" class="column is-flex">
        <resource-snippet
          :title="$prismicText(prismicContent.resource2_description)"
          :link="prismicContent.resource2_link"
          :image="require('@/assets/ressource-02.svg')"
        />
      </div>
      <div v-if="$prismicHasText(prismicContent.resource3_description)" class="column is-flex">
        <resource-snippet
          :title="$prismicText(prismicContent.resource3_description)"
          :link="prismicContent.resource3_link"
          :image="require('@/assets/ressource-03.svg')"
        />
      </div>
      <div v-if="$prismicHasText(prismicContent.resource4_description)" class="column is-flex">
        <resource-snippet
          :title="$prismicText(prismicContent.resource4_description)"
          :link="prismicContent.resource4_link"
          :image="require('@/assets/ressource-04.svg')"
        />
      </div>
      <div v-if="$prismicHasText(prismicContent.resource5_description)" class="column is-flex">
        <resource-snippet
          :title="$prismicText(prismicContent.resource5_description)"
          :link="prismicContent.resource5_link"
          :image="require('@/assets/ressource-05.svg')"
        />
      </div>
    </div>
  </ui-box>
</template>

<script>
import UiBox from '@/components/ui/box'
import ResourceSnippet from '@/components/dashboards/resource-snippet'

export default {
  components: {
    UiBox,
    ResourceSnippet
  },
  props: {
    prismicContent: {
      Type: Object
    }
  }
}
</script>